import $ from 'jquery';

let $html;
let $icons;
let $iconTooltip;
let $iconsContainer;
let $iconsTop;

function cacheDom(){
    $html = $('html');
    $icons = $html.find('.info-block-icon');
    $iconTooltip = $html.find('.info-block-icon-tooltip');
    $iconsContainer = $($iconTooltip).prev();
}

function handleProductIconClick(e) {
    const $el = $(e.target);

    if ( $el.hasClass('is-active') ) {  //Set state to null

        $el.removeClass('is-active');
        $iconsContainer.removeClass('is-open');
        $(document).off('click', handleClick.bind(this))
        setTimeout(function() {
            $iconTooltip.html('');
        }, 500);
    } else { // Set active state

        $icons.removeClass('is-active');
        $el.addClass('is-active');
        $iconTooltip.html( $el.find('.info-block-icon-info').html() );
        $iconsContainer.addClass('is-open');
        $(document).on('click', handleClick.bind(this));
    }
}

function handleClick(e){
    e.stopPropagation();
    console.log(e)
    if (e.target.className.indexOf('info-block-icon') > -1 ){
        handleProductIconClick(e);
    } else if (e.target.className.indexOf('info-block-icon-tooltip') > -1) {
        return;
    } else {
        $(document).off('click', handleClick)
        $iconsContainer.removeClass('is-open');
        $icons.removeClass('is-active');
    }
}

function handleScroll(){
    if ( ( innerHeight + window.scrollY ) > $iconsTop ) {
        $html.addClass('icons-inview');
        $(document).off('scroll', handleScroll)
    }
}

function addEvents() {
    if ( $icons.length > 0 ) {
        $icons.each(function(i, el){
            $(el).on('click', handleClick.bind(this));
        });

        if ( innerWidth < 1024) {
            $iconsTop = $($icons[0]).offset().top;
            $(document).on('scroll', handleScroll);
        }
    }
}

function init() {
    cacheDom();
    addEvents();
}

export default {
    init
};
